import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { srcSetFor } from "@/lib/responsive";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-muted px-4">
    <div className="text-center max-w-md">
      <Link to="/"><img src={logo} srcSet={srcSetFor(logo)} sizes="300px" alt="JTB Floors" width={1536} height={1024} decoding="async" className="h-24 w-auto mx-auto mb-6" /></Link>
      <h1 className="mb-3 text-4xl font-heading font-black">Page not found</h1>
      <p className="mb-6 text-muted-foreground">The page you're looking for doesn't exist or has moved.</p>
      <nav aria-label="Helpful links" className="flex flex-wrap justify-center gap-4 mb-6 text-sm font-medium">
        <Link to="/" className="text-primary hover:underline">Home</Link>
        <Link to="/services" className="text-primary hover:underline">Services</Link>
        <Link to="/our-work" className="text-primary hover:underline">Our Work</Link>
        <Link to="/contact" className="text-primary hover:underline">Contact</Link>
      </nav>
      <Button asChild className="btn-shine gap-2">
        <a href="tel:17739342004"><Phone className="w-4 h-4" /> Call (773) 934-2004</a>
      </Button>
    </div>
  </div>
);

export default NotFound;
